// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#widget-container .separator {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin: 16px 0;
}

#widget-container .line {
  flex-grow: 1;
  height: 1px;
  background-color: #ccc;
}

#widget-container .date {
  padding: 0 12px;
  color: #333;
  text-align: center;
  font-family: "McKinseySans-Regular";
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/components/timestamp/styles.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,mCAAmC;EACnC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB","sourcesContent":["#widget-container .separator {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  margin: 16px 0;\n}\n\n#widget-container .line {\n  flex-grow: 1;\n  height: 1px;\n  background-color: #ccc;\n}\n\n#widget-container .date {\n  padding: 0 12px;\n  color: #333;\n  text-align: center;\n  font-family: \"McKinseySans-Regular\";\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
